<!-- <ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav> -->
<div class="page-content-wrapper">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view">
      <ol class="breadcrumb bc-3"  >
        <li>
        <a [routerLink]="'/home'">Home</a>
        </li>
        <li>
        <a>Risk Management</a>
        </li>
      </ol>
      <div class="inner-wrapper risk-overlap">
        <div class="sub-wrapper">
          <h3 class="page-title obs-card-title" style="text-align:center">
            <span class="page-sub-title">Job Safety Analysis (JSA)</span><button *ngIf="selectedRiskRequestId > 0"
              (click)="isNext ? onNextClick() : $event.preventDefault()" [ngClass]="isNext ? 'cursor-pointer':'disabled'"
              class="pull-right btn btn-primary primary-btn"><i class="fa fa-angle-right"></i></button>
            <button *ngIf="selectedRiskRequestId > 0"
              (click)="isPrevious ? onPreviousClick() : $event.preventDefault()"
              [ngClass]="isPrevious ? 'cursor-pointer':'disabled'" class="pull-right btn btn-primary primary-btn"><i
                class="fa fa-angle-left"></i>
            </button></h3>
          <!-- <div class="section-wrapper right">
            <span class="mandatory-info">Fields marked with
              <span class="mandatory">*</span> are mandatory</span>
          </div> -->
          <div class="section-wrapper import">
            <div class=" left excel-download" style="float: left;"  >
            <a *ngIf="ShowButton===true"
            (click)="fileUploadDialog = true"
                    class="btn btn-primary primary-btn export-btn button-excel"
                    role="button"
                  >
                    <i class="fa fa-file-excel-o" style="padding-right: 10px"></i>
                     Import From Excel
                  </a>
                  <a download="JSA.xlsx" class="btn btn-primary primary-btn export-btn button-excel" href="assets/ImportFiles/JSA.xlsx">Download Template</a>
                  <a *ngIf="selectedRiskRequestId > 0" (click)="ExportToExcel()" class="btn btn-primary primary-btn export-btn button-zip cursor-pointer">Download JSA</a>
                </div>
            <div class=" right">
              <span class="mandatory-info">Fields marked with
                <span class="mandatory">*</span> are mandatory</span>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                <label for="sel1">
                  Job Safety Analysis Number
                </label>
              </span>
              <input type="text" class="form-control" [(ngModel)]="riskRequest.RiskRequestJSA.JSANumber" [disabled]="true">             
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">Unit <i class="fa fa-info-circle"
                  pTooltip="Unit are enabled for interaction based on permission of User"></i><span class="mandatory">*</span> 
              </span>
              <p-tree [value]="unitTree" selectionMode="single" (onNodeSelect)="nodeSelected($event)"
                [(selection)]="selectedUnit" [styleClass]="disableRisk ? 'disabled' : 'cursor-pointer'"></p-tree>
                <span class="error-msg-colour" *ngIf="unitError">Please select
  
                  unit</span>
            </div>
            <div class="sub-section-wrapper" [hidden]="isEmployeeUnit">
              <span class="section-sub-title">Contract Number <span class="mandatory">*</span></span>
              <p-dropdown [options]="contracts"  placeholder="Select"  [(ngModel)]="selectedContractId" 
              [style]="{'width':'100%'}"
              (onChange)="checkHolder($event)" >
              
              </p-dropdown>
             
              <div *ngIf="isContractErrorMsg && !riskRequest.ContractId">
              <span class="error-msg-colour">Please select Contract</span>
              <span class="error-msg-colour"
              *ngIf="!isHasContractDetails">Contract Holder is not available for this contract. Please contact admin to update these details. 
              </span>
              </div>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">{{ 'RISK.RISK_IDENTIFIED_BY' | translate }}
  
                <span class="mandatory">*</span>
              </span>
              <p-autoComplete [(ngModel)]="selectedUserEmp" [suggestions]="userResults" appendTo="body"
                (completeMethod)="getUsersOnSearch($event)" placeholder="Employee Name" field="FullName" [minLength]="1"
                [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [forceSelection]="true"
                [disabled]="disableRisk" >
                <ng-template let-employee pTemplate="item">
                  <span [title]="employee.Email">{{employee.FullName}}</span>
                </ng-template>
              </p-autoComplete>
              <div *ngIf="isRiskReportErrorMsg && selectedUserEmp?.UserId === 0">
                <span class="error-msg-colour">Kindly Select Employee Name</span>
              </div>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">{{ "RISK.LOCATION" | translate }}
                <span class="mandatory">*</span></span>
              <p-dropdown [options]="locations" placeholder="Select" [(ngModel)]="selectedLocation"
                [style]="{ width: '100%' }" (onChange)="saveLocation()" [disabled]="disableRisk  || (selectedRiskRequestId > 0 && riskRequest.Status !== 'Draft' && isInactiveLocation && !independentPermissions.APP_Admin && !independentPermissions.HSE_Admin && !independentPermissions.SUPER_Admin)"></p-dropdown>
                <div *ngIf="displayErrorMessage.showLocationErrorMessage && !riskRequest.LocationId">
                  <span class="error-msg-colour">Kindly select Location.</span>
                </div>
                <div *ngIf="isInactiveLocation">
              <span class="error-msg-colour">This Location is In Active.</span>
            </div>
            </div>
            <ara-exact-location [Location]="riskRequest.ExactLocation" [Disabled]="disableRisk"
              (Output)="setLocation($event)"></ara-exact-location>
            <!-- <div *ngIf="riskRequest.ExactLocation.trim() === '' && displayErrorMessage.showExactLocationErrorMessage">
                <span class="error-msg-colour">Kindly Select Exact Location.</span>
            </div> -->

            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                <label for="sel1">Risk Source<span class="mandatory">*</span></label>
              </span>
              <select class="form-control" value="0" [(ngModel)]="riskRequest.RiskSourceId" [disabled]="disableRisk">
                <option value="0">Select</option>
                <option *ngFor="let riskSource of raiseRiskAllMaster.RiskSource" value={{riskSource.RiskSourceId}}
                  [selected]="riskRequest.RiskSourceId === riskSource.RiskSourceId">
                  {{riskSource.Source}}
                </option>
              </select>
              <div *ngIf="(riskRequest.RiskSourceId === 0) && displayErrorMessage.showRiskSourceErrorMessage">
                <span class="error-msg-colour">{{ 'RISK.KINDLY_SELECT_RISK_SOURCE' | translate }}</span>
              </div>
            </div>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title">
                <label for="sel1">Project Name<span class="mandatory">*</span></label></span>
              <select class="form-control" value="0" [(ngModel)]="riskRequest.ProjectId" [disabled]="disableRisk">
                <option value="0">Select</option>
                <option *ngFor="let project of raiseRiskAllMaster.Project" value={{project.ProjectId}}
                  [selected]="riskRequest.ProjectId === project.ProjectId">
                  {{project.ProjectName}}
                </option>
              </select>
              <div *ngIf="(riskRequest.ProjectId === 0) && displayErrorMessage.showProjectNameErrorMessage">
                <span class="error-msg-colour">{{ 'RISK.KINDLY_SELECT_PROJECT_NAME' | translate }}</span>
              </div>
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                <label for="sel1">
                  Risk/Hazard Title
                  <span class="mandatory">*</span>
                </label>
              </span>
              <input type="text" class="form-control" [(ngModel)]="riskRequest.RiskTitle" [disabled]="disableRisk">
              <div *ngIf="riskRequest.RiskTitle.trim() === '' && displayErrorMessage.showRiskTitleErrorMessage">
                <span class="error-msg-colour">{{ 'RISK.KINDLY_ENTER_RISK_TITLE' | translate }}</span>
              </div>
            </div>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title">
                <label for="sel1">
                  Risk Management Tool
                  <span class="mandatory">*</span>
                </label></span>
              <select class="form-control" value="0" [(ngModel)]="riskRequest.RiskManagementToolId"
                [disabled]="disableRisk">
                <option value="0">Select</option>
                <option *ngFor="let riskManagement of raiseRiskAllMaster.RiskManagementTool"
                  value={{riskManagement.RiskManagementToolId}}
                  [selected]="riskRequest.RiskManagementToolId === riskManagement.RiskManagementToolId">
                  {{riskManagement.ToolName}}
                </option>
              </select>
              <div
                *ngIf="(riskRequest.RiskManagementToolId === 0) && displayErrorMessage.showRiskManagementToolErrorMessage">
                <span class="error-msg-colour">{{ 'RISK.KINDLY_SELECT_RISK_MANAGEMENT_TOOL' | translate }}</span>
              </div>
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                <label for="comment">
                  Activity Leading to Hazard
                  <span class="mandatory">*</span>
                </label></span>
              <ara-textarea [sourceText]="riskRequest.ActivityLeadingToHazard" [disabled]="disableRisk" rows="4" cols="30"
                (output)="getRemarks($event,'ActivityLeadingToHazard',0)"></ara-textarea>
              <!-- <div *ngIf="riskRequest.ActivityLeadingToHazard.length >= 999">
                <span class="error-msg-colour">
                  You can enter upto 1000 characters.
                </span>
              </div> -->
              <div
                *ngIf="riskRequest.ActivityLeadingToHazard.trim() === '' && displayErrorMessage.showActivityLeadingToHazardErrorMessage">
                <span class="error-msg-colour">{{ 'RISK.KINDLY_ENTER_ACTIVITY_WHICH_LEADS_TO_A_HAZARD' | translate
                  }}</span>
              </div>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                <label for="comment">
                  Hazard Identified
                  <span class="mandatory">*</span>
                </label></span>
              <ara-textarea [sourceText]="riskRequest.HazardIdentified"  [disabled]="disableRisk" rows="4" cols="30"
                (output)="getRemarks($event,'HazardIdentified',0)"></ara-textarea>
              <!-- <div *ngIf="riskRequest.HazardIdentified.length >= 999">
                <span class="error-msg-colour">
                  You can enter upto 1000 characters.
                </span>
              </div> -->
              <div
                *ngIf="riskRequest.HazardIdentified.trim() === '' && displayErrorMessage.showHazardIdentifiedErrorMessage">
                <span class="error-msg-colour">{{ 'RISK.KINDLY_ENTER_DETAILS_OF_HAZARDS_IDENTIFIED' | translate }}</span>
              </div>
            </div>
            <span class="section-sub-title">
              <label for="comment">
                Threat Identified
                <span class="mandatory">*</span>
              </label></span>
            <ara-textarea [sourceText]="riskRequest.ThreatIdentified"  [disabled]="disableRisk" rows="4" cols="30"
              (output)="getRemarks($event,'ThreatIdentified',0)"></ara-textarea>
            <!-- <div *ngIf="riskRequest.ThreatIdentified.length >= 999">
              <span class="error-msg-colour">
                You can enter upto 1000 characters.
              </span>
            </div> -->
            <div
              *ngIf="riskRequest.ThreatIdentified.trim() === '' && displayErrorMessage.showThreatIdentifiedErrorMessage">
              <span class="error-msg-colour">{{ 'RISK.KINDLY_ENTER_DETAILS_OF_THREATS_IDENTIFIED' | translate }}</span>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div class="sub-section-wrapper consequences">
              <span class="section-sub-title ">
                <label for="comment">
                  Consequences
                  <span class="mandatory">*</span>
                </label></span>
              <ara-textarea [sourceText]="riskRequest.Consequences"  [disabled]="disableRisk" rows="4" cols="30"
                (output)="getRemarks($event,'Consequences',0)"></ara-textarea>
              <!-- <div *ngIf="riskRequest.Consequences.length >= 999">
                <span class="error-msg-colour">
                  You can enter upto 1000 characters.
                </span>
              </div> -->
              <div *ngIf="riskRequest.Consequences.trim() === '' && displayErrorMessage.showConsequencesErrorMessage">
                <span class="error-msg-colour">{{ 'RISK.KINDLY_ENTER_CONSEQUENCES' | translate }}</span>
              </div>
            </div>
            <!--START:: PEARN SECTION -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                Potential Risk Identified<span class="mandatory">*</span>
                <span class="risk-matrix" data-toggle="modal" data-target="#lineGraph">
                  <a (click)="sendtoLineGraph()" [ngStyle]="{'color': 'white'}" 
                    pTooltip="Please select all Severity and Likelihood before opening graph."
                    tooltipPosition="top">Graph</a>
                </span>
                <span class="risk-matrix" data-toggle="modal" data-target="#risk-matrix"  style="margin-right:16px;">RAM</span>
              </span>
              <div>
  
                <table>
                  <thead>
                  <tr style="text-align: left;">
                    <td>
                        <label for="sel1">{{ 'RISK.PEARN' | translate }}<span class="mandatory">*</span></label>
                    </td>
                    <td>
                        <label for="sel1">Severity<span class="mandatory">*</span></label>
                    </td>
                    <td>
                        <label for="sel1">Likelihood<span class="mandatory">*</span></label>
                    </td>
                    <td >
                        <label for="sel1">Risk<span class="mandatory"></span></label>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr style="text-align:left">
                    <td >
                      <label>{{ 'RISK.PEOPLE' | translate }}</label>
                    </td>
                    <td>
  
                        <select class="form-control" value="0" [disabled]="disableRisk"
                         (change)="getRiskColor('Potential', 'People')" [(ngModel)]="PotentialPeopleRisk.PeopleRiskSeverity">
  
                         <option *ngFor="let severity of severityMaster" value={{severity.Value}}
                           [selected]="PotentialPeopleRisk.PeopleRiskSeverity === severity">{{severity.Name}}</option>
                       </select>
  
                    </td>
                    <td>
                      <select class="form-control" value="0" [disabled]="disableRisk"
                      (change)="getRiskColor('Potential', 'People')"
                      [(ngModel)]="PotentialPeopleRisk.PeopleRiskLikelihood">
  
                      <option *ngFor="let consequence of consequenceMaster" value={{consequence.Value}}
                        [selected]="PotentialPeopleRisk.PeopleRiskLikelihood === consequence">{{consequence.Name}}
                      </option>
                    </select>
                    </td>
                    <td>
                      <span
                        [ngClass]="PotentialPeopleRisk.PeopleRiskColor !== '' ? 'risk-band ' + PotentialPeopleRisk.PeopleRiskColor : ''">{{PotentialPeopleRisk.PeopleRiskColor
                          !== '' ? getTexts(PotentialPeopleRisk.PeopleRiskColor,'People'):''}}</span>
                    </td>
                  </tr>
                  <tr style="text-align: left;">
                    <td>
                      <label>{{ 'RISK.ENVIRONMENT' | translate }}</label>
                    </td>
                    <td>
                      <select class="form-control" value="0" [disabled]="disableRisk"
                      (change)="getRiskColor('Potential', 'Environment')"
                      [(ngModel)]="PotentialEnvironmentRisk.EnvironmentRiskSeverity">
  
                      <option *ngFor="let severity of environmentMaster" value={{severity.Value}}
                        [selected]="PotentialEnvironmentRisk.EnvironmentRiskSeverity === severity">{{severity.Name}}
                      </option>
                    </select>
                    </td>
                    <td>
                      <select class="form-control" value="0" [disabled]="disableRisk"
                      (change)="getRiskColor('Potential', 'Environment')"
                      [(ngModel)]="PotentialEnvironmentRisk.EnvironmentRiskLikelihood">
  
                      <option *ngFor="let consequence of consequenceMaster" value={{consequence.Value}}
                        [selected]="PotentialEnvironmentRisk.EnvironmentRiskLikelihood === consequence">
                        {{consequence.Name}}
                      </option>
                    </select>
                    </td>
                    <td>
                      <span
                      [ngClass]="PotentialEnvironmentRisk.EnvironmentRiskColor !== '' ? 'risk-band ' + PotentialEnvironmentRisk.EnvironmentRiskColor : ''">{{PotentialEnvironmentRisk.EnvironmentRiskColor
                        !== '' ? getTexts(PotentialEnvironmentRisk.EnvironmentRiskColor,'Environment'):''}}</span>
                    </td>
                  </tr>
                  <tr style="text-align: left;">
                    <td>
                      <label>{{ 'RISK.ASSETS' | translate }}</label>
                    </td>
                    <td>
                      <select class="form-control" value="0" [disabled]="disableRisk"
                      (change)="getRiskColor('Potential', 'Assets')" [(ngModel)]="PotentialAssetsRisk.AssetsRiskSeverity">
  
                      <option *ngFor="let severity of assetsMaster" value={{severity.Value}}
                        [selected]="PotentialAssetsRisk.AssetsRiskSeverity === severity">{{severity.Name}}</option>
                    </select>
                    </td>
                    <td>
                      <select class="form-control" value="0" [disabled]="disableRisk"
                      (change)="getRiskColor('Potential', 'Assets')"
                      [(ngModel)]="PotentialAssetsRisk.AssetsRiskLikelihood">
  
                      <option *ngFor="let consequence of consequenceMaster" value={{consequence.Value}}
                        [selected]="PotentialAssetsRisk.AssetsRiskLikelihood === consequence">{{consequence.Name}}
                      </option>
                    </select>
                    </td>
                    <td>
                      <span
                      [ngClass]="PotentialAssetsRisk.AssetsRiskColor !== '' ? 'risk-band ' + PotentialAssetsRisk.AssetsRiskColor : ''">{{PotentialAssetsRisk.AssetsRiskColor
                        !== '' ? getTexts(PotentialAssetsRisk.AssetsRiskColor,'Assets'):''}}</span>
                    </td>
                  </tr>
                  <tr style="text-align: left;">
                    <td>
                      <label>{{ 'RISK.REPUTATION' | translate }}</label>
                    </td>
                    <td>
                      <select class="form-control" value="0" [disabled]="disableRisk"
                      (change)="getRiskColor('Potential', 'Reputation')"
                      [(ngModel)]="PotentialReputationRisk.ReputationRiskSeverity">
  
                      <option *ngFor="let severity of reputationMaster" value={{severity.Value}}
                        [selected]="PotentialReputationRisk.ReputationRiskSeverity === severity">{{severity.Name}}
                      </option>
                    </select>
                    </td>
                    <td>
                      <select class="form-control" value="0" [disabled]="disableRisk"
                      (change)="getRiskColor('Potential', 'Reputation')"
                      [(ngModel)]="PotentialReputationRisk.ReputationRiskLikelihood">
  
                      <option *ngFor="let consequence of consequenceMaster" value={{consequence.Value}}
                        [selected]="PotentialReputationRisk.ReputationRiskLikelihood === consequence">{{consequence.Name}}
                      </option>
                    </select>
                    </td>
                    <td>
                      <span
                      [ngClass]="PotentialReputationRisk.ReputationRiskColor !== '' ? 'risk-band ' + PotentialReputationRisk.ReputationRiskColor : ''">{{PotentialReputationRisk.ReputationRiskColor
                        !== '' ? getTexts(PotentialReputationRisk.ReputationRiskColor,'Reputation'):''}}</span>
                    </td>
                  </tr>
                  <tr style="text-align: left;">
                    <td>
                      <label>Non-Productive Time</label>
                    </td>
                    <td>
                      <select class="form-control" value="0" [disabled]="disableRisk"
                      (change)="getRiskColor('Potential', 'NPT')" [(ngModel)]="PotentialNPTRisk.NPTRiskSeverity">
  
                      <option *ngFor="let severity of NPTMaster" value={{severity.Value}}
                        [selected]="PotentialNPTRisk.NPTRiskSeverity === severity">{{severity.Name}}
                      </option>
                    </select>
                    </td>
                    <td>
                      <select class="form-control" value="0" [disabled]="disableRisk"
                      (change)="getRiskColor('Potential', 'NPT')" [(ngModel)]="PotentialNPTRisk.NPTRiskLikelihood">
  
                      <option *ngFor="let consequence of consequenceMaster" value={{consequence.Value}}
                        [selected]="PotentialNPTRisk.NPTRiskLikelihood === consequence">{{consequence.Name}}
                      </option>
                    </select>
                    </td>
                    <td>
                      <span
                      [ngClass]="PotentialNPTRisk.NPTRiskColor !== '' ? 'risk-band ' + PotentialNPTRisk.NPTRiskColor : ''">{{PotentialNPTRisk.NPTRiskColor
                        !== '' ? getTexts(PotentialNPTRisk.NPTRiskColor,'NPT'):''}}</span>
                    </td>
                  </tr>
                </tbody>
                </table>
              </div>
              <div class="clearfix"></div>
            </div>
            <!--END:: PEARN SECTION -->
           <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title">
                <label for="sel1">
                  Risk Management Tool
                  <span class="mandatory">*</span>
                </label></span>
              <select class="form-control" value="0" [disabled]="true">
                <option value="0">JSA</option>                
              </select>
            </div> -->
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title">
                <label for="sel1">
                  Job Safety Analysis Number
                </label>
              </span>
              <input type="text" class="form-control" [(ngModel)]="riskRequest.RiskRequestJSA.JSANumber" [disabled]="true">             
            </div> -->
            <div *ngIf="checkImport === 0 || checkImport === 1">
              <ara-category [moduleId]="moduleId" [riskManagementToolId] = "riskManagementToolId" [isActive]="isActive" [sourceId]="selectedRiskRequestId" [checkImport]="checkImport" [ImportedCategoryData]="specificationResponseData" [disabled]="disableRisk"
              (categoryCheckedValueEmittedData)="categoryCheckedEmittedValue($event)">
              </ara-category>
            </div>  
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                <label for="sel1">
                  Title Of Job
                  <span class="mandatory">*</span>
                </label>
              </span>
              <input type="text" class="form-control" [(ngModel)]="riskRequest.RiskRequestJSA.JSATitle" [disabled]="disableRisk">
              <div *ngIf="riskRequest.RiskRequestJSA.JSATitle.trim() === '' && displayErrorMessage.showJSATitleErrorMessage">
                <span class="error-msg-colour">{{ 'RISK.KINDLY_ENTER_JOB_TITLE' | translate }}</span>
              </div>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                <label for="sel1">
                  Number of Steps in Job
                  <span class="mandatory">*</span>
                </label>
              </span>
              <input type="text" class="form-control" [(ngModel)]="riskRequest.RiskRequestJSA.NoOfSteps" [disabled]="true">
              <div *ngIf="riskRequest.RiskRequestJSA.NoOfSteps == 0 && displayErrorMessage.showJSAStepsErrorMessage">
                <span class="error-msg-colour">{{ 'RISK.KINDLY_ENTER_JSA_STEPS' | translate }}</span>
              </div>
            </div>     
            <div class="sub-section-wrapper">
              <button type="button" class="btn btn-primary primary-btn button-draft" (click)="addStep()">
                    Add Steps</button>	
            </div> 
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <span class="page-title obs-card-title"> Authorization </span>
            <div class="sub-section-wrapper">
              <span class="section-sub-title"><b>Review & Approved by Contractor : </b></span>   
              <div class="sub-section-wrapper">
                <span class="section-sub-title">
                  <label for="sel1">
                    Name
                  </label>
                </span>
                <p-autoComplete [(ngModel)]="selectedContractor" [suggestions]="userResults" appendTo="body"
                (completeMethod)="getUsersOnSearch($event)" placeholder="Contractor Name" field="FullName" [minLength]="1"
                [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [forceSelection]="true"
                [disabled]="disableRisk || ContractorApproval > 0 || ContractorApproved > 0" >
                <ng-template let-employee pTemplate="item">
                  <span [title]="employee.Email">{{employee.FullName}}</span>
                </ng-template>
                </p-autoComplete>
                <!-- <input type="text" class="form-control" [(ngModel)]="riskRequest.RiskRequestJSA.ContractorName">                -->
              </div>  
              <div class="sub-section-wrapper" *ngIf="selectedRiskRequestId>0">
                <span class="section-sub-title">
                  <label for="sel1">
                    Designation
                  </label>
                </span>
                <input type="text" class="form-control" [(ngModel)]="riskRequest.RiskRequestJSA.ContractorDesignation" [disabled]="true">               
              </div>      
              <!-- <div class="sub-section-wrapper">
                <span class="section-sub-title">
                  <label for="sel1">
                    Date
                  </label>
                </span>
                <p-calendar hourFormat="12" [(ngModel)]="riskRequest.RiskRequestJSA.ContractorDate" [showIcon]="true"
                dateFormat="dd/mm/yy" [showTime]="false" readonlyInput="true" appendTo="body"
                hideOnDateTimeSelect="true"  monthNavigator="true" yearNavigator="true"
                yearRange="1950:2100">
              </p-calendar>              
              </div>    -->
              <!-- <div class="sub-section-wrapper">
                
                  <label class="radio-inline">
                    <input type="radio" name="ContractorApprove" value="1"
                      [(ngModel)]="ContractorApprove" />
                    Approved
                  </label>
                  <label class="radio-inline">
                    <input type="radio" name="ContractorApprove" value="2"
                      [(ngModel)]="ContractorApprove" />
                    Rejected
                  </label>
              </div>                 -->
              <div class="sub-section-wrapper" *ngIf="ContractorApproval > 0  || riskRequest.RiskRequestJSA.ContractorIsApproved > 0">
                <span class="section-sub-title">
                  <label for="ContRemark">
                    Remark:
                  </label></span>
                <ara-textarea [sourceText]="riskRequest.RiskRequestJSA.ContractorApprovalRemark" [maxLength]="1000" [disabled]="riskRequest.RiskRequestJSA.ContractorIsApproved !=0"
                  (output)="getRemarks($event,'ContractorApprovalRemark',0)"></ara-textarea>
                <div *ngIf="riskRequest.RiskRequestJSA.ContractorApprovalRemark && riskRequest.RiskRequestJSA.ContractorApprovalRemark.length >= 999">
                  <span class="error-msg-colour">
                    You can enter upto 1000 characters.
                  </span>
                </div>
                <div
                *ngIf="riskRequest.RiskRequestJSA.ContractorApprovalRemark.trim() === '' && displayErrorMessage.showContractorApprovalRemarkErrorMessage">
                <span class="error-msg-colour">Kindly Enter Remarks</span>
                </div>
                 
              </div>   
              <div class="sub-section-wrapper" *ngIf="selectedRiskRequestId>0">
                <span class="section-sub-title">
                  <label for="sel1">
                    Status : {{ContractorApprovalStatus}}
                  </label>
                </span>
              </div>     
              <div class="sub-section-wrapper" *ngIf="ContractorApproval > 0 && riskRequest.RiskRequestJSA.ContractorIsApproved === 0">
                <input type="button" class="btn btn-primary button-submit"
                (click)="saveApprovals('Contractor',true)" value="Approve">
                <input type="button" class="btn btn-primary button-reject"
                (click)="saveApprovals('Contractor',false)" value="Reject">
              </div>      
              <div class="clearfix"></div>
            </div>

            <div class="sub-section-wrapper">
              <span class="section-sub-title"><b>Review & Approved by Admin/Staff : </b></span>   
              <div class="sub-section-wrapper">
                <span class="section-sub-title">
                  <label for="sel1">
                    Name
                  </label>
                </span>
                <!-- <input type="text" class="form-control" [(ngModel)]="riskRequest.RiskRequestJSA.StaffName">     -->
                <p-autoComplete [(ngModel)]="selectedStaff" [suggestions]="userResults" appendTo="body"
                (completeMethod)="getUsersOnSearch($event)" placeholder="Admin/Staff Name" field="FullName" [minLength]="1"
                [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [forceSelection]="true"
                [disabled]="disableRisk || StaffApproval > 0 || StaffApproved > 0" >
                <ng-template let-employee pTemplate="item">
                  <span [title]="employee.Email">{{employee.FullName}}</span>
                </ng-template>
                </p-autoComplete>           
              </div>  
              <div class="sub-section-wrapper" *ngIf="selectedRiskRequestId>0">
                <span class="section-sub-title">
                  <label for="sel1">
                    Designation
                  </label>
                </span>
                <input type="text" class="form-control" [(ngModel)]="riskRequest.RiskRequestJSA.StaffDesignation" [disabled]="true">               
              </div>      
              <!-- <div class="sub-section-wrapper">
                <span class="section-sub-title">
                  <label for="sel1">
                    Date
                  </label>
                </span>
                <p-calendar hourFormat="12" [(ngModel)]="riskRequest.RiskRequestJSA.StaffDate" [showIcon]="true"
                dateFormat="dd/mm/yy" [showTime]="false" readonlyInput="true" appendTo="body"
                hideOnDateTimeSelect="true"  monthNavigator="true" yearNavigator="true"
                yearRange="1950:2100">
              </p-calendar>              
              </div>    -->
              <!-- <div class="sub-section-wrapper">
                
                  <label class="radio-inline">
                    <input type="radio" name="StaffApprove" value="1"
                      [(ngModel)]="StaffApprove" />
                    Approved
                  </label>
                  <label class="radio-inline">
                    <input type="radio" name="StaffApprove" value="2"
                      [(ngModel)]="StaffApprove" />
                    Rejected
                  </label>
              </div>                 -->
              <div class="sub-section-wrapper" *ngIf="StaffApproval > 0 || StaffApproved > 0 || riskRequest.RiskRequestJSA.UserIsApproved > 0">
                <span class="section-sub-title">
                  <label for="UserApprovalRemark">
                    Remark:
                  </label></span>
                <ara-textarea [sourceText]="riskRequest.RiskRequestJSA.UserApprovalRemark" [maxLength]="1000" [disabled]="riskRequest.RiskRequestJSA.UserIsApproved>0"
                  (output)="getRemarks($event,'UserApprovalRemark',0)"></ara-textarea>
                <div *ngIf="riskRequest.RiskRequestJSA.UserApprovalRemark && riskRequest.RiskRequestJSA.UserApprovalRemark.length >= 999">
                  <span class="error-msg-colour">
                    You can enter upto 1000 characters.
                  </span>
                </div>
                <div
                  *ngIf="riskRequest.RiskRequestJSA.UserApprovalRemark.trim() === '' && displayErrorMessage.showUserApprovalRemarkErrorMessage">
                  <span class="error-msg-colour">Kindly Enter Remarks</span>
                </div>
              </div>   
              <div class="sub-section-wrapper" *ngIf="selectedRiskRequestId>0">
                <span class="section-sub-title">
                  <label for="sel1">
                    Status : {{UserApprovalStatus}}
                  </label>
                </span>
              </div>  
              <div class="sub-section-wrapper" *ngIf="StaffApproval > 0 && StaffApproved == 0 && riskRequest.RiskRequestJSA.UserIsApproved===0 ">
                <input type="button" class="btn btn-primary button-submit"
                (click)="saveApprovals('Staff',true)" value="Approve">
                <input type="button" class="btn btn-primary button-reject"
                (click)="saveApprovals('Staff',false)" value="Reject">
              </div>            
              <div class="clearfix"></div>
            </div>
            <ara-record-actions *ngIf="selectedRiskRequestId>0" [SourceId]="selectedRiskRequestId" ModuleName="Risk"
              [ShowCancel]="riskRequest.Status !=='Deleted' && riskRequest.Status!=='Cancelled'"
              [ShowDelete]="independentPermissions.SUPER_Admin && riskRequest.Status !=='Cancelled' && riskRequest.Status !='Deleted'"
              [ShowRestate]="(riskPermission.RSK_Admin || riskPermission.RSK_Admin_Unit || independentPermissions.SUPER_Admin) && riskRequest.Status==='Cancelled'"
              [Status]="riskRequest.Status" (output)="getOutput($event)"></ara-record-actions>
          </div>
          <div class="clearfix"></div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="section-wrapper add-action-wrapper">
              <span class="page-title obs-card-title">{{ 'RISK.ADD_STEPS' | translate }}</span>
              <div class="table-responsive margin-bottom-20 add-action-table">
                <table style="align-content: center;"
                  class="table table-bordered table-striped table-condensed tableheader table-red">
                  <tbody *ngFor="let action of JSAStepsList; let i = index">
                
                    <tr>
                      <td style="width: 200px">
                        <strong>Step Details</strong>
                        <br>
                        <ara-textarea [sourceText]="action.StepDetails"
                        [disabled]="(!riskPermission.RSK_Admin_Unit && !riskPermission.RSK_Admin  && action.ActionId > 0) || (action?.Status==='Deleted' || action?.Status==='Closed' || action?.Status === 'Cancelled') || (riskRequest.Status==='Cancelled' || riskRequest.Status==='Deleted')"
                        (output)="getRemarks($event,'JSAStepDetails',i)"></ara-textarea>
                      <div *ngIf="!action.StepDetails && action.ShowErrorMessage">
                        <span class="error-msg-colour">{{ 'RISK.PROVIDE_STEP_DETAILS' | translate }}</span>
                      </div>
                       
                      </td>
                      <td style="width: 200px">
                        <strong>Potential Hazard</strong>
                        <br>
                        <ara-textarea [sourceText]="action.PatentialHazards"
                        (output)="getRemarks($event,'JSAPatentialHazards',i)"></ara-textarea>
                      <div *ngIf="!action.PatentialHazards && action.ShowErrorMessage">
                        <span class="error-msg-colour">{{ 'RISK.PROVIDE_POTENTIAL_HAZARD' | translate }}</span>
                      </div>
                      </td>
                      <td style="width: 200px">
                        <strong>Control Measures</strong>
                        <br>
                        <ara-textarea [sourceText]="action.ControlMeasures" 
                        (output)="getRemarks($event,'JSAControlMeasures',i)"></ara-textarea>
                      <div *ngIf="!action.ControlMeasures && action.ShowErrorMessage">
                        <span class="error-msg-colour">{{ 'RISK.PROVIDE_STEP_CONTROL_MEASURES' | translate }}</span>
                      </div>
                      </td>
                      <td style="width: 120px" class="input-person">
                        <strong>Name of Responsible Person</strong>
                        <br>
                       <p-autoComplete [(ngModel)]="action.ResponsiblePerson" [suggestions]="userResults"
                          (completeMethod)="getUsersOnSearch($event)" (onSelect)="selectResponsiblePerson($event, i)"
                          (change)="selectResponsiblePerson($event, i)" placeholder="" appendTo="body"
                          field="FullName" [minLength]="1" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                          [forceSelection]="true">
                          <ng-template let-ResponsiblePerson pTemplate="item">
                            <span [title]="ResponsiblePerson.Email">{{ResponsiblePerson.FullName}}</span>
                          </ng-template>
                        </p-autoComplete>
                        <div *ngIf="action.ShowErrorMessage">
                          <span class="error-msg-colour">{{ 'RISK.KINDLY_SELECT_RESPONSIBLE_PERSON' | translate }}</span>
                        </div> 
                      </td>
                      <td style="width: 50px"
                        *ngIf="(riskPermission.RSK_Admin || riskPermission.RSK_Admin_Unit)">
                        <a  (click)="removeStepFromList(i)"
                          (click)="removeStepFromList(i)">
                          <i class="fa fa-trash"></i>
                        </a>
                        
                       
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- End table-responsive -->
              <a (click)="addStep()" class="pull-right margin-top-10">
                <i class="fa fa-plus" aria-hidden="true" style="padding-right:6px;"></i>Add Step
              </a>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="section-wrapper add-action-wrapper"
              >
              <span class="section-title">{{ 'RISK.ADD_ACTION_YOU_WANT_TO_TAKE' | translate }}</span>
              <div class="table-responsive margin-bottom-20 add-action-table">
                <table style="align-content: center;"
                  class="table table-bordered table-striped table-condensed tableheader table-red">
                  <tbody *ngFor="let action of actionList; let i = index">
                    <tr *ngIf="(independentPermissions.SUPER_Admin || riskPermission.RSK_Admin || riskPermission.RSK_Admin_Unit) || (!independentPermissions.SUPER_Admin && !riskPermission.RSK_Admin_Unit && !riskPermission.RSK_Admin)">
                      <th colspan="6" class="action-details-th">
                        <a class="action-details" [ngClass]="action.ActionId > 0 ? 'cursor-pointer' : 'disabled'"
                          (click)="action.ActionId > 0 ? showActions(action.ActionId,action.ProcessId) : $event.preventDefault()"><i
                            class="fa fa-hand-o-up"></i> {{ 'RISK.ACTION' | translate }}
                            <ng-container *ngIf="action.ActionId > 0">{{ action.ActionId }}</ng-container>
                          </a>
                        <span class="action-details-status">
                          <label style="margin: 0;">Status :<span
                              style="margin-left: 5px;">{{action.Status}}</span></label>
                        </span>
                      </th>
                    </tr>
                    <tr *ngIf="(independentPermissions.SUPER_Admin || riskPermission.RSK_Admin || riskPermission.RSK_Admin_Unit) || (!independentPermissions.SUPER_Admin && !riskPermission.RSK_Admin_Unit && !riskPermission.RSK_Admin)">
                      <td colspan="6">
                        <ara-textarea [sourceText]="action.Action" [maxLength]="1000" rows="4" cols="30"
                          [disabled]="(!riskPermission.RSK_Admin_Unit && !riskPermission.RSK_Admin  && action.ActionId > 0) || (action?.Status==='Deleted' || action?.Status==='Closed' || action?.Status === 'Cancelled') || (riskRequest.Status==='Cancelled' || riskRequest.Status==='Deleted')"
                          (output)="getRemarks($event,'Action',i)"></ara-textarea>
                        <div *ngIf="!action.Action && action.ShowActionErrorMessage">
                          <span class="error-msg-colour">{{ 'RISK.PROVIDE_ACTION_DETAILS' | translate }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="(independentPermissions.SUPER_Admin || riskPermission.RSK_Admin || riskPermission.RSK_Admin_Unit) || (!independentPermissions.SUPER_Admin && !riskPermission.RSK_Admin_Unit && !riskPermission.RSK_Admin)">
                      <td style="width: 200px">
                        <strong>Action Owner</strong>
                        <br>
                        <p-autoComplete [(ngModel)]="action.ActionOwner" [suggestions]="userResults"
                          (completeMethod)="getUsersOnSearch($event)" (onSelect)="selectActionOwner($event, i)"
                          (change)="selectActionOwner($event, i)" placeholder="Action Owner" appendTo="body"
                          [disabled]="(!riskPermission.RSK_Admin_Unit && !riskPermission.RSK_Admin  && action.ActionId > 0) || (action?.Status==='Deleted' || action?.Status==='Closed' || action?.Status === 'Cancelled') || (riskRequest.Status==='Cancelled' || riskRequest.Status==='Deleted')"
                          field="FullName" [minLength]="1" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                          [forceSelection]="true">
                          <ng-template let-actionowner pTemplate="item">
                            <span [title]="actionowner.Email">{{actionowner.FullName}}</span>
                          </ng-template>
                        </p-autoComplete>
                        <div *ngIf="action.ShowActionOwnerErrorMessage">
                          <span class="error-msg-colour">{{ 'RISK.KINDLY_SELECT_ACTION_OWNER' | translate }}</span>
                        </div>
                      </td>
                      <td style="width: 200px">
                        <strong>Action Party</strong>
                        <br>
                        <p-autoComplete [(ngModel)]="action.selectedActionParty" [suggestions]="userResults"
                          (completeMethod)="getUsersOnSearch($event)" (onSelect)="selectActionParty($event,i)"
                          [disabled]="(!riskPermission.RSK_Admin_Unit && !riskPermission.RSK_Admin  && action.ActionId > 0) || (action?.Status==='Deleted' || action?.Status==='Closed' || action?.Status === 'Cancelled') || (riskRequest.Status==='Cancelled' || riskRequest.Status==='Deleted')"
                          (change)="selectActionParty($event,i)" placeholder="Action Party" field="FullName"
                          [minLength]="1" [style]="{'width':'100%'}" appendTo="body" [inputStyle]="{'width':'100%'}"
                          [forceSelection]="true">
                          <ng-template let-actionparty pTemplate="item">
                            <span [title]="actionparty.Email">{{actionparty.FullName}}</span>
                          </ng-template>
                        </p-autoComplete>
                        <div class="margin-top-10" *ngIf="action.ShowActionPartyErrorMessage">
                          <span class="error-msg-colour">{{ 'RISK.KINDLY_SELECT_ACTION_PARTY' | translate }}</span>
                        </div>
                      </td>
                      <td style="width: 90px">
                        <strong>Priority</strong>
                        <br>
                        <select class="form-control" id="sel1" [(ngModel)]="action.Priority"
                          [disabled]="(!riskPermission.RSK_Admin_Unit && !riskPermission.RSK_Admin  && action.ActionId > 0) || (action?.Status==='Deleted' || action?.Status==='Closed' || action?.Status === 'Cancelled') || (riskRequest.Status==='Cancelled' || riskRequest.Status==='Deleted')">
                          <option [ngValue]=0>Select</option>
                          <option [ngValue]=3>High</option>
                          <option [ngValue]=2>Medium</option>
                          <option [ngValue]=1>Low</option>
                        </select>
                        <div *ngIf="!action.Priority && action.ShowPriorityErrorMessage">
                          <span class="error-msg-colour">{{ 'RISK.KINDLY_SELECT_PRIORITY' | translate }}</span>
                        </div>
                      </td>
                      <td style="width: 120px">
                        <strong>Target Date</strong>
                        <br>
                        <div class="p-calendar">
                          <p-calendar [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true" placeholder=""
                            [(ngModel)]="action.TargetDate" readonlyInput="true" required #timeOfUse="ngModel"
                            [disabled]="(!riskPermission.RSK_Admin_Unit && !riskPermission.RSK_Admin  && action.ActionId > 0) || (action?.Status==='Deleted' || action?.Status==='Closed' || action?.Status === 'Cancelled') || (riskRequest.Status==='Cancelled' || riskRequest.Status==='Deleted')"
                            appendTo="body" hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true"
                            yearRange="1950:2100">
                          </p-calendar>
                          <div *ngIf="!action.TargetDate">
                            <span class="error-msg-colour">{{ 'RISK.KINDLY_SELECT_TARGET_DATE' | translate }}</span>
                          </div>
                        </div>
                      </td>
                      <td style="width: 300px">
                        <ara-file-upload [accept]="accept" [multiple]="multiple" [(inputFiles)]="action.Files"
                          (onInputFilesUpdatedData)="onInputFilesUpdated($event,'RiskAction',i)"
                          [disabled]="(!riskPermission.RSK_Admin_Unit && !riskPermission.RSK_Admin && action.ActionId > 0) || (action?.Status==='Deleted' || action?.Status==='Closed' || action?.Status === 'Cancelled') || (riskRequest.Status==='Cancelled' || riskRequest.Status==='Deleted')">
                        </ara-file-upload>
                        <ara-files-previewer [files]="action.FilesPreview"></ara-files-previewer>
                      </td>
                      <td style="width: 50px"
                        *ngIf="(riskPermission.RSK_Admin || riskPermission.RSK_Admin_Unit)">
                        <a *ngIf="action.ActionId === 0" (click)="removeActionFromActionList(i)"
                          (click)="removeActionFromActionList(i)">
                          <i class="fa fa-trash"></i>
                        </a>
                        <a (click)="cancelAssigned(action.ActionId,i)"
                          *ngIf="(riskPermission.RSK_Admin || riskPermission.RSK_Admin_Unit) && action.ActionId>0">
                          <i class="fa fa-times" data-toggle="tooltip" pTooltip="Cancel Action" tooltipPosition="top"></i>
                        </a>
                        <a (click)="deleteAssigned(action.ActionId,i)"
                          *ngIf="(riskPermission.RSK_Admin || riskPermission.RSK_Admin_Unit) && action.ActionId>0">
                          <i class="fa fa-trash" data-toggle="tooltip" pTooltip="Delete Action" tooltipPosition="top"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- End table-responsive -->
              <a (click)="addAction()" class="pull-right margin-top-10">
                <i class="fa fa-plus" aria-hidden="true" style="padding-right:6px;"></i>Add Action
              </a>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
          </div>

          <footer>
            <a [routerLink]="['../../risk-overview']" role="button" class="btn button-float-left button-back">
              <i class="fa fa-reply"></i>Back to Overview</a>
              <button type="button"
              *ngIf="selectedRiskRequestId > 0"
              (click)="ReportshowDialog()"
              class="btn btn-primary primary-btn button-report-log button-float-left"
               >Report Log
              </button>
              <button type="button"
              *ngIf="selectedRiskRequestId > 0"
              (click)="ApprovershowDialog()"
              class="btn btn-primary primary-btn button-report-log button-float-left"
               >Approver Log
              </button>
              <div *ngIf="Approval === 0">
                <button type="button" class="btn btn-primary primary-btn button-draft" (click)="saveAsDraft()" *ngIf="
                            (selectedRiskRequestId === 0 || riskRequest.Status === 'Draft') && ShowButton===true">
                          <i class="fa fa-envelope"></i>Save As Draft</button>	
              <!-- <a *ngIf="selectedRiskRequestId !== 0" (click)="downloadPDF()" class="btn btn-primary primary-btn button-pdf"
                role="button" [ngClass]="'cursor-pointer'">
                <i class="fa fa-file-pdf-o"></i>Download PDF</a> -->
              <a *ngIf="selectedRiskRequestId === 0 && ShowButton===true" (click)="confirmResetForm()" class="btn btn-primary primary-btn button-reset"
                role="button">
                <i class="fa fa-refresh"></i>reset</a>
              <a *ngIf="(selectedRiskRequestId === 0 || riskRequest.Status === 'Draft') && ShowButton===true" (click)="raiseRiskJSA()" class="btn btn-primary primary-btn button-submit"
                role="button">
                <i class="fa fa-share-square"></i>submit</a>
              <a *ngIf="!isInactiveLocation && riskRequest.Status !== 'Draft' && selectedRiskRequestId !== 0 && ShowButton===true && (!disableRisk || riskPermission.RSK_Admin || riskPermission.RSK_Admin_Unit || riskOwner)"
                (click)="updateRisk()" class="btn btn-primary primary-btn button-update" role="button">
                <i class="fa fa-share-square"></i>update</a>
              </div>   
              <div style="float: right;" *ngIf="riskRequest.Status !== 'Draft' && selectedRiskRequestId !== 0 && ShowButton===false && (ShowApproveButton===true || riskOwner || riskPermission.RSK_Admin || riskPermission.RSK_Admin_Unit)">
                <a  *ngIf="!isInactiveLocation && riskRequest.Status !== 'Draft' && selectedRiskRequestId !== 0 && ShowButton===false && (ShowApproveButton===true || riskOwner || riskPermission.RSK_Admin || riskPermission.RSK_Admin_Unit)"
                (click)="updateAction()" class="btn btn-primary primary-btn button-update" role="button">
                <i class="fa fa-share-square"></i>Update Actions</a>
              </div>
              <div *ngIf="Approval > 0 && ShowApproveButton===true">
                <ara-record-actions  [SourceId]="selectedRiskRequestId" ModuleName="Risk" ApprovalLevel={{Approval}}              
                  [ShowAccept]="true"
                  [ShowReject]="true"
                  [Status]="riskRequest.Status" (output)="getOutputApproveReject($event)"></ara-record-actions>
              </div>
              
          </footer>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
  <ara-alerts [alertType]="alertType" [successDetails]="successDetails" [errorDetails]="errorDetails"
    (okClicked)="onYesClickedSuccess()" [confirmMessage]="confirmMessage" (yesClicked)="onYesClickedForConfirmation()"
    (noClicked)="onNoClickedForConfirmation()"></ara-alerts>
    <span *ngIf="ReportclosePopup">
      <p-dialog header="Report History" [(visible)]="ReportclosePopup" (onHide)="ReportclosePopUp()" [modal]="true">
       <ara-report-log [ReportUserId]="ReportUserId" [ReportModule]="ReportModule"
         [ReportRecordId]="ReportRecordId">
       </ara-report-log>
     </p-dialog> 
    </span>
    <span *ngIf="ApproverPopup">
      <p-dialog header="Approver Details" [(visible)]="ApproverPopup" (onHide)="ApproverclosePopUp()" [modal]="true">
       <ara-approver-log [RiskId]="RiskId">
       </ara-approver-log>
     </p-dialog> 
    </span> 
  <p-dialog header="Cancellation Remarks" [(visible)]="cancelRecord" modal="modal" width="500">
    <ara-textarea [sourceText]="cancellationReason" [maxLength]="1000" disabled="false"
      (output)="getRemarks($event,'CancellationReason',0)"></ara-textarea>
    <div *ngIf="showCancellationmsg && !cancellationReason ">
      <span class="error-msg-colour">{{ 'RISK.PLEASE_ENTER_CANCELLATION_REMARKS.' | translate }}</span>
  
    </div>
    <p-footer>
      <button type="button" pButton (click)="checkPopUpValidation('Cancel',cancelActionId)" label="Submit"
        class="active-btn orange-btn button-submit"></button>
      <button type="button" pButton (click)="onCancelClick()" label="Cancel" class="active-btn orange-btn button-cancel"></button>
    </p-footer>
  </p-dialog>
  <p-dialog header="Deletion Remarks" [(visible)]="deleteRecord" modal="modal" width="500">
    <ara-textarea [sourceText]="deletionReason" [maxLength]="1000" disabled="false"
      (output)="getRemarks($event,'DeletionReason',0)"></ara-textarea>
    <div *ngIf="showDeletionmsg && !deletionReason ">
      <span class="error-msg-colour">{{ 'RISK.PLEASE_ENTER_DELETION_REMARKS.' | translate }}</span>
  
    </div>
    <p-footer>
      <button type="button" pButton (click)="checkPopUpValidation('Delete',deleteActionId)" label="Submit"
        class="active-btn orange-btn button-submit"></button>
      <button type="button" pButton (click)="onCancel()" label="Cancel" class="active-btn orange-btn button-cancel"></button>
    </p-footer>
  </p-dialog>
  <div class="modal fade" id="risk-matrix" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close button-cancel" data-dismiss="modal">&times;</button>
          <!-- <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </button> -->
          <h4 class="modal-title custom_align" id="Heading">Risk Assessment Matrix</h4>
        </div>
        <div class="modal-body">
          <img class="ram-img" width="100%" src="assets/images/incident-ram.png" />
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
  
  <div class="modal fade" id="lineGraph" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close button-cancel" data-dismiss="modal">&times;</button>
          <!-- <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </button> -->
          <h4 class="modal-title custom_align" id="Heading">Risk Graph</h4>
        </div>
        <div class="modal-body">
          <ara-line-graph></ara-line-graph>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
  
   
<p-dialog
[(visible)]="fileUploadDialog"
(onHide)="closePopUp()"
header="Import Data From Excel"
[modal]="true"
[style]="{ width: '500px' }"
>
<div class="p-field">

 
  <label for="name" style="margin-top: 10px">
    Select Excel File:<span class="mandatory">*</span></label>
    <input type="file" (change)="onSelectFile($event)" multiple="false" />
</div>
<ng-template pTemplate="footer">
  <button
    pButton
    pRipple
    label="Import"
    [disabled]="disableImport"
    (click)="ImportExcel()"
    icon="pi pi-check"
    class="p-button-text"
  ></button>
  <button
    pButton
    pRipple
    label="Cancel"
    (click)="fileUploadDialog = false"
    icon="pi pi-times"
    class="p-button-text button-cancel"
  ></button>
</ng-template>
</p-dialog>
<span *ngIf="isShowErrorDialog">
  <p-dialog header="Import Errors" [(visible)]="isShowErrorDialog" (onHide)="ImportErrorclosePopUp()" [modal]="true">
   <ara-import-error [ImportErrorList]="ImportErrorList">
   </ara-import-error>
 </p-dialog> 
</span>